import { useSyncExternalStore } from 'react'

// Dark mode is driven by the `dark` class on <html> (see ThemeProvider).
// useSyncExternalStore + a MutationObserver keeps components in sync with the
// toggle without any setState-in-effect pattern.

function subscribe(onChange: () => void): () => void {
  if (typeof document === 'undefined') return () => {}
  const observer = new MutationObserver(onChange)
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
  return () => observer.disconnect()
}

function getSnapshot(): boolean {
  return typeof document !== 'undefined' && document.documentElement.classList.contains('dark')
}

function getServerSnapshot(): boolean {
  return false
}

export function useIsDark(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
